import { Button } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import './FilterBadge.css';

const FilterBadge = ({ filterDef, value, onClick }) => {
  if (!filterDef) return <div />;

  return (
    <div className="filter-badge-container">
      <div className="label">{filterDef.label}</div>
      <Button
        key={filterDef.key}
        onClick={onClick}
        style={{ minWidth: `${Math.max(value.length + 1, (filterDef.label.length + 1) / 2)}em` }}
        endIcon={<ClearIcon />}
      >
        {filterDef.render(value)}
      </Button>
    </div>
  );
};

export default FilterBadge;
